<template>
  <nav class="page-tabs" role="tablist" :aria-label="ariaLabel">
    <component
      v-for="tab in tabs"
      :key="tab.key"
      :is="tab.to ? 'router-link' : 'button'"
      :to="tab.to"
      :type="tab.to ? undefined : 'button'"
      role="tab"
      class="page-tab"
      :class="{ active: tab.key === modelValue }"
      :aria-selected="tab.key === modelValue ? 'true' : 'false'"
      v-on:click="!tab.to && $emit('update:modelValue', tab.key)"
    >
      <BaseIcon v-if="tab.icon" :name="tab.icon" />
      {{ tab.label }}
      <span class="page-tab-count" v-if="tab.count">{{ tab.count }}</span>
    </component>
  </nav>
</template>

<script>
import { defineAsyncComponent } from "vue";

const BaseIcon = defineAsyncComponent(() => import("../icons/BaseIcon.vue"));

// The tab list of a page, in the look of the settings pages' tabs. A tab is { key, label, icon?, count?, to? }: with
// `to` it is a link to another page (the page tells which one is active), without it a switch inside the page.
export default {
  name: "PageTabs",
  components: { BaseIcon },
  props: {
    tabs: { type: Array, required: true },
    modelValue: String,
    ariaLabel: String,
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.page-tabs {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.25rem;
  background: var(--pf-soft);
  border-radius: 0.75rem;
}
.page-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  min-height: 2.25rem;
  padding: 0 0.875rem;
  border: 0;
  border-radius: 0.5625rem;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--pf-text);
  text-decoration: none;
  cursor: pointer;
}
.page-tab.active {
  background: var(--ws-accent, var(--pf-accent, #713ae8));
  font-weight: 800;
  color: #fff;
}
.page-tab.active .page-tab-count {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}
.page-tab :deep(.icon) {
  display: flex;
}
.page-tab :deep(svg) {
  width: 1.125rem;
  height: 1.125rem;
}
.page-tab-count {
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 99rem;
  padding: 0.0625rem 0.5rem;
  background: var(--pf-accent-soft);
  color: var(--pf-accent-dark);
}
</style>
